const sprites = `
        <!-- SVG Sprite -->
        
        <!-- Fingerprint -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-fingerprint">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M9 9a1 1 0 1 1 2 0v5a1 1 0 0 1-1 1c-2.472 0-4-2.018-4-4V9c0-2.007 1.53-4 4-4 2.47 0 4 1.993 4 4v1.5a.5.5 0 1 0 1 0V9c0-2.69-2.148-5-5-5S5 6.31 5 9v2.3c0 2.197 2.106 4.7 5 4.7 1.229 0 2.337-.415 3.36-1.268a1 1 0 1 1 1.28 1.536C13.263 17.415 11.705 18 10 18c-4.083 0-7-3.467-7-6.7V9c0-3.763 3.01-7 7-7s7 3.237 7 7v1.5a2.5 2.5 0 1 1-5 0V9c0-1-.767-2-2-2S8 8 8 9v2c0 .676.368 1.372 1 1.738V9z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Rebilly Logo -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="rebilly-logo">
                <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 393 150">
                    <path id="XMLID_53_" class="st0" d="M193 68c-9.4 0-17 7.6-17 17s7.6 17 17 17 17-7.6 17-17-7.6-17-17-17zm-17 41v9h-18V20h18v41s6.4-10 22-10c16.5 0 30 15.3 30 34s-13.5 34-30 34c-15.3 0-22-10-22-10z"/>
                    <path id="XMLID_52_" class="st0" d="M348.2 114.1L322 52h18.7l16.8 42 16.8-42H393l-40.8 98h-18.6z"/>
                    <path id="XMLID_49_" class="st0" d="M29 67h18c8.3 0 15-6.7 15-15s-6.7-15-15-15H29v30zm6.5 17H29v34H10V20h40c17.6 0 32 14.4 32 32 0 14.8-10.1 27.6-24.5 31.1l-1.4.3 24.3 34.5H57.5L35.5 84z"/>
                    <path id="XMLID_46_" class="st0" d="M116 66c-12.6 0-15.6 12-15.6 12h31.1c.1 0-2.9-12-15.5-12zM82 85c0-20 14-34 34-34s34 14 34 34c0 1.7-.1 3.4-.3 5H100v1c0 7.2 7.2 13 16 13 6 0 12.3-2.7 15.6-6.7l13.5 9c-6.4 8.2-16.7 12.7-29.1 12.7-20 0-34-14-34-34z"/>
                    <path id="XMLID_45_" class="st0" d="M236 52h18v66h-18z"/>
                    <path id="XMLID_44_" class="st0" d="M266 36h18v82h-18z"/>
                    <path id="XMLID_32_" class="st0" d="M296 20h18v98h-18z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Rebilly Logo fixed -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-rebilly-logo">
                <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 393 150">
                    <path id="XMLID_53_" class="st0" d="M193 68c-9.4 0-17 7.6-17 17s7.6 17 17 17 17-7.6 17-17-7.6-17-17-17zm-17 41v9h-18V20h18v41s6.4-10 22-10c16.5 0 30 15.3 30 34s-13.5 34-30 34c-15.3 0-22-10-22-10z"/>
                    <path id="XMLID_52_" class="st0" d="M348.2 114.1L322 52h18.7l16.8 42 16.8-42H393l-40.8 98h-18.6z"/>
                    <path id="XMLID_49_" class="st0" d="M29 67h18c8.3 0 15-6.7 15-15s-6.7-15-15-15H29v30zm6.5 17H29v34H10V20h40c17.6 0 32 14.4 32 32 0 14.8-10.1 27.6-24.5 31.1l-1.4.3 24.3 34.5H57.5L35.5 84z"/>
                    <path id="XMLID_46_" class="st0" d="M116 66c-12.6 0-15.6 12-15.6 12h31.1c.1 0-2.9-12-15.5-12zM82 85c0-20 14-34 34-34s34 14 34 34c0 1.7-.1 3.4-.3 5H100v1c0 7.2 7.2 13 16 13 6 0 12.3-2.7 15.6-6.7l13.5 9c-6.4 8.2-16.7 12.7-29.1 12.7-20 0-34-14-34-34z"/>
                    <path id="XMLID_45_" class="st0" d="M236 52h18v66h-18z"/>
                    <path id="XMLID_44_" class="st0" d="M266 36h18v82h-18z"/>
                    <path id="XMLID_32_" class="st0" d="M296 20h18v98h-18z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Dashboard -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-dashboard">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M15.606 5.808l-.899.9a1 1 0 0 1-1.414-1.415l.9-.9A6.969 6.969 0 0 0 10 3a6.969 6.969 0 0 0-4.192 1.394l.9.899a1 1 0 0 1-1.415 1.414l-.9-.9A6.964 6.964 0 0 0 3.072 9H4a1 1 0 1 1 0 2h-.93a7.002 7.002 0 0 0 13.86 0H16a1 1 0 0 1 0-2h.93a6.964 6.964 0 0 0-1.324-3.192zM9.031 8.25A1.002 1.002 0 0 1 9 8V6a1 1 0 1 1 2 0v2c0 .086-.01.17-.031.25a2 2 0 1 1-1.938 0zM10 19a9 9 0 1 1 0-18 9 9 0 0 1 0 18z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Lists -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-lists">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M2 3h2a1 1 0 1 1 0 2H2a1 1 0 1 1 0-2zm6 0h10a1 1 0 0 1 0 2H8a1 1 0 1 1 0-2zM2 7h2a1 1 0 1 1 0 2H2a1 1 0 1 1 0-2zm6 0h10a1 1 0 0 1 0 2H8a1 1 0 1 1 0-2zm-6 4h2a1 1 0 0 1 0 2H2a1 1 0 0 1 0-2zm6 0h10a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2zm-6 4h2a1 1 0 0 1 0 2H2a1 1 0 0 1 0-2zm6 0h10a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Automation -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-automation">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M16.245 9H17a2 2 0 0 1 2 2v1a2 2 0 0 1-1.004 1.735c.003.088.004.176.004.265v5H2v-5c0-.089.001-.177.004-.265A2 2 0 0 1 1 12v-1a2 2 0 0 1 2-2h.755A7.99 7.99 0 0 1 9 6.062v-1.33a2 2 0 1 1 2 0v1.33A7.99 7.99 0 0 1 16.245 9zM4 17h12v-3a6 6 0 1 0-12 0v3zm4-6a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm4 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Customer -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-customers">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M13.41 13.655c1.866.745 3.45 2.09 4.458 3.848.274.48.11 1.09-.37 1.365-.48.274-1.09.108-1.365-.37C14.906 16.357 12.563 15 10 15c-2.55 0-4.9 1.366-6.134 3.5-.276.478-.888.642-1.366.366-.478-.276-.642-.888-.366-1.366 1.01-1.75 2.598-3.095 4.46-3.842C5.614 12.745 5 11.443 5 10V6c0-2.76 2.24-5 5-5s5 2.243 5 5v4c0 1.442-.612 2.742-1.59 3.655zM7 6v4c0 1.65 1.343 3 3 3 1.654 0 3-1.343 3-3V6c0-1.65-1.343-3-3-3-1.653 0-3 1.343-3 3z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Order -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-orders">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M16 9v8.993c0 .556-.313.695-.71.296l-.58-.578a1 1 0 0 0-1.42 0l-.58.578a1 1 0 0 1-1.42 0l-.58-.578a1 1 0 0 0-1.42 0l-.58.578a1 1 0 0 1-1.421 0l-.58-.578a1 1 0 0 0-1.42 0l-.579.578c-.392.393-.71.261-.71-.296V9H1.99A1.99 1.99 0 0 1 0 7.002V1.997C0 1.447.455 1 .992 1h18.016c.548 0 .992.453.992.997v5.005A1.999 1.999 0 0 1 18.01 9H16zm0-2h2V3H2v4h2V5h12v2zm-9 3c0 .556.444 1 .99 1h4.02a1 1 0 0 0 .99-1c0-.556-.444-1-.99-1H7.99A1 1 0 0 0 7 10zm0 4c0 .556.444 1 .99 1h4.02a1 1 0 0 0 .99-1c0-.556-.444-1-.99-1H7.99A1 1 0 0 0 7 14z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Transaction -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-transactions">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M12 15H9a1 1 0 0 1 0-2h7.002c.549 0 .998-.45.998-1 0-.557-.444-1-.998-1h-2.004A3.001 3.001 0 0 1 11 8c0-1.662 1.34-3 2.998-3H14V3.01a1 1 0 1 1 2 0V5h2a1 1 0 0 1 0 2h-4.002A.994.994 0 0 0 13 8c0 .55.45 1 .998 1h2.004A2.994 2.994 0 0 1 19 12c0 1.656-1.345 3-2.998 3H16v1.99a1 1 0 1 1-2 0V15h-2zm-7 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2zM9 5a1 1 0 1 1 0 2H5a1 1 0 1 1 0-2h4zm0 4a1 1 0 1 1 0 2H7a1 1 0 0 1 0-2h2zM3 9a1 1 0 1 1 0 2H2a1 1 0 0 1 0-2h1z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Guide -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-guides">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M1 5.018a.995.995 0 0 1 .129-.51C1.976 3.007 4.079 2 6 2c1.435 0 2.964.556 4.002 1.462C11.04 2.557 12.57 2 14 2c1.928 0 4.027 1.003 4.872 2.511.09.16.131.335.128.507V16.98a1 1 0 0 1-1.872.509C16.672 16.676 15.258 16 14 16c-1.246 0-2.658.673-3.123 1.48A.994.994 0 0 1 10 18a.994.994 0 0 1-.877-.522C8.659 16.67 7.252 16 6 16c-1.252 0-2.671.679-3.129 1.491A1 1 0 0 1 1 16.981V5.017zm2 .28v9.477A6.443 6.443 0 0 1 6 14c1.023 0 2.094.282 3 .773V5.296C8.446 4.572 7.157 4 6 4c-1.151 0-2.443.574-3 1.298zm14-.002C16.446 4.572 15.157 4 14 4c-1.151 0-2.443.574-3 1.298v9.477A6.443 6.443 0 0 1 14 14c1.023 0 2.094.282 3 .773V5.296z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Setting -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-settings">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M14.724 11.644l.277-.797.832.14a1 1 0 1 0 0-1.973L15 9.153l-.277-.797a4.962 4.962 0 0 0-.21-.511l-.306-.638.5-.5a1 1 0 0 0-1.414-1.414l-.501.499-.638-.305a4.962 4.962 0 0 0-.511-.21l-.797-.278.14-.832a1 1 0 1 0-1.973 0L9.153 5l-.797.277c-.174.06-.345.131-.511.21l-.638.306-.5-.5a1 1 0 0 0-1.414 1.414l.499.501-.305.638c-.08.166-.15.337-.21.511l-.278.797-.832-.14a1 1 0 1 0 0 1.973L5 10.847l.277.797c.06.174.131.345.21.511l.306.638-.5.5a1 1 0 0 0 1.414 1.414l.501-.499.638.305c.166.08.337.15.511.21l.797.278-.14.832a1 1 0 1 0 1.973 0L10.847 15l.797-.277c.174-.06.345-.131.511-.21l.638-.306.5.5a1 1 0 0 0 1.414-1.414l-.499-.501.305-.638c.08-.166.15-.337.21-.511zM17 14a3 3 0 0 1-4.105 2.79 3.001 3.001 0 0 1-5.79 0 3 3 0 0 1-3.895-3.895 3.001 3.001 0 0 1 0-5.79A3 3 0 0 1 7.105 3.21a3.001 3.001 0 0 1 5.79 0 3 3 0 0 1 3.895 3.895 3.001 3.001 0 0 1 0 5.79c.137.346.21.72.21 1.105zm-7-1a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Notification -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-notifications">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M14.293 14.707A1 1 0 0 1 14 14V8.001a4 4 0 1 0-8 0V14a1 1 0 0 1-.293.707L5.414 15h9.172l-.293-.293zM10.997 2.082A6.003 6.003 0 0 1 16 8.002v5.584l1.707 1.707c.63.63.184 1.707-.707 1.707h-5a2 2 0 1 1-4 0H3c-.89 0-1.337-1.077-.707-1.707L4 13.586V8a6.007 6.007 0 0 1 5.003-5.918 1 1 0 1 1 1.993 0z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Stream -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-stream">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M2.636 3.293A1 1 0 0 1 4.05 4.707a7 7 0 0 0 0 9.9 1 1 0 0 1-1.414 1.414 9 9 0 0 1 0-12.728zM5.464 6.12A1 1 0 0 1 6.88 7.536a3 3 0 0 0 0 4.242 1 1 0 0 1-1.415 1.414 5 5 0 0 1 0-7.07zM10 11.657a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm7.364 4.364a1 1 0 1 1-1.414-1.414 7 7 0 0 0 0-9.9 1 1 0 0 1 1.414-1.414 9 9 0 0 1 0 12.728zm-2.828-2.829a1 1 0 0 1-1.415-1.414 3 3 0 0 0 0-4.242 1 1 0 0 1 1.415-1.415 5 5 0 0 1 0 7.071z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Search -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-search">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M15.427 14.096a.998.998 0 0 1 .28.197l2 2a1 1 0 0 1-1.414 1.414l-2-2a.998.998 0 0 1-.197-.28 7.5 7.5 0 1 1 1.332-1.332zM9.5 15a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zm0-9a1 1 0 0 1 0 2A1.5 1.5 0 0 0 8 9.5a1 1 0 0 1-2 0A3.5 3.5 0 0 1 9.5 6z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Filter -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-filter">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M10 8.586L13.586 5H6.414L10 8.586zm1 1.828V16a1 1 0 0 1-2 0v-5.586L3.293 4.707C2.663 4.077 3.109 3 4 3h12c.89 0 1.337 1.077.707 1.707L11 10.414z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Collapse Segments -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-collapse-segments">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M5 5h10a1 1 0 0 1 0 2H5a1 1 0 1 1 0-2zm0 4h6a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2zm0 4h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Resize Columns -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-resize-columns">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M13.586 9l-1.293-1.293a1 1 0 1 1 1.414-1.414l3 3a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1-1.414-1.414L13.586 11H6.414l1.293 1.293a1 1 0 0 1-1.414 1.414l-3-3a1 1 0 0 1 0-1.414l3-3a1 1 0 0 1 1.414 1.414L6.414 9h7.172zM17 2a1 1 0 1 1 0 2 1 1 0 0 1 0-2zM3 2a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm14 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zM3 5a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm14 8a1 1 0 1 1 0 2 1 1 0 0 1 0-2zM3 13a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm14 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zM3 16a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Segments -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-segments">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M10 10h6v1a7 7 0 1 1-7-7h1v6zm-6 1c0 2.79 2.261 5 5.05 5 2.444 0 4.482-1.695 4.95-4H8V6c-2.305.468-4 2.557-4 5zm14-3v1h-7V2h1a6 6 0 0 1 6 6zm-5-4v3h3a4.183 4.183 0 0 0-3-3z"/>
                </svg>
            </symbol>
        </svg>
        <!-- lock -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-lock">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M3 10.997A2 2 0 0 1 5.006 9h9.988C16.102 9 17 9.896 17 10.997v5.006A2.001 2.001 0 0 1 14.994 18H5.006A2.003 2.003 0 0 1 3 16.003v-5.006zm2 5.006c0-.005 9.994-.003 9.994-.003C15 16 15 10.997 15 10.997c0 .005-9.994.003-9.994.003C5 11 5 16.003 5 16.003zM10 2a5 5 0 0 1 5 5v2h-2V7a3 3 0 0 0-6 0v2H5V7a5 5 0 0 1 5-5z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Caret Up -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-caret-up">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M5.707 13.707a1 1 0 0 1-1.414-1.414l5-5a1 1 0 0 1 1.414 0l5 5a1 1 0 1 1-1.414 1.414L10 9.414l-4.293 4.293z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Caret Down -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-caret-down">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M5.707 7.293a1 1 0 0 0-1.414 1.414l5 5a1 1 0 0 0 1.414 0l5-5a1 1 0 1 0-1.414-1.414L10 11.586 5.707 7.293z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Caret Down Small -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-caret-down-s">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M10 10.586l2.293-2.293a1 1 0 0 1 1.414 1.414l-3 3a.997.997 0 0 1-1.414 0l-3-3a1 1 0 0 1 1.414-1.414L10 10.586z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Caret Left -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-caret-left">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M12.707 5.707a1 1 0 1 0-1.414-1.414l-5 5a1 1 0 0 0 0 1.414l5 5a1 1 0 0 0 1.414-1.414L8.414 10l4.293-4.293z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Caret Right -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-caret-right">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M7.293 14.293a1 1 0 0 0 1.414 1.414l5-5a1 1 0 0 0 0-1.414l-5-5a1 1 0 0 0-1.414 1.414L11.586 10l-4.293 4.293z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Arrow Up -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-arrow-up">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M9 7.414V15a1 1 0 0 0 2 0V7.414l2.293 2.293a1 1 0 0 0 1.414-1.414l-4-4a.997.997 0 0 0-1.414 0l-4 4a1 1 0 0 0 1.414 1.414L9 7.414z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Arrow Down -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-arrow-down">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M11 12.586V5a1 1 0 0 0-2 0v7.586l-2.293-2.293a1 1 0 0 0-1.414 1.414l4 4a.997.997 0 0 0 1.414 0l4-4a1 1 0 0 0-1.414-1.414L11 12.586z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Arrow Left -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-arrow-left">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M7.414 11H15a1 1 0 0 0 0-2H7.414l2.293-2.293a1 1 0 0 0-1.414-1.414l-4 4a.997.997 0 0 0 0 1.414l4 4a1 1 0 0 0 1.414-1.414L7.414 11z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Arrow Right -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-arrow-right">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M12.586 11H5a1 1 0 0 1 0-2h7.586l-2.293-2.293a1 1 0 0 1 1.414-1.414l4 4a.997.997 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L12.586 11z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Arrow Up Large -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-arrow-up-l">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M9.44 2.17a.998.998 0 0 1 1.267.123l7 7a1 1 0 1 1-1.414 1.414L11 5.414V17a1 1 0 0 1-2 0V5.414l-5.293 5.293a1 1 0 1 1-1.414-1.414l7-7c.047-.047.098-.089.15-.124z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Arrow Down Large -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-arrow-down-l">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M9.44 17.83a.998.998 0 0 0 1.267-.123l7-7a1 1 0 1 0-1.414-1.414L11 14.586V3a1 1 0 0 0-2 0v11.586L3.707 9.293a1 1 0 1 0-1.414 1.414l7 7c.047.047.098.089.15.124z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Arrow Left Large -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-arrow-left-l">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M2.17 9.44a.998.998 0 0 0 .123 1.267l7 7a1 1 0 1 0 1.414-1.414L5.414 11H17a1 1 0 0 0 0-2H5.414l5.293-5.293a1 1 0 1 0-1.414-1.414l-7 7a1.005 1.005 0 0 0-.124.15z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Arrow Right Large -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-arrow-right-l">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M17.83 10.56a.998.998 0 0 0-.123-1.267l-7-7a1 1 0 1 0-1.414 1.414L14.586 9H3a1 1 0 0 0 0 2h11.586l-5.293 5.293a1 1 0 1 0 1.414 1.414l7-7c.047-.047.089-.098.124-.15z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Close -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-close">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M10 11.414l4.293 4.293a1 1 0 0 0 1.414-1.414L11.414 10l4.293-4.293a1 1 0 1 0-1.414-1.414L10 8.586 5.707 4.293a1 1 0 0 0-1.414 1.414L8.586 10l-4.293 4.293a1 1 0 0 0 1.414 1.414L10 11.414z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Close Small -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-close-s">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M10 11.414l3.293 3.293a1 1 0 0 0 1.414-1.414L11.414 10l3.293-3.293a1 1 0 1 0-1.414-1.414L10 8.586 6.707 5.293a1 1 0 0 0-1.414 1.414L8.586 10l-3.293 3.293a1 1 0 0 0 1.414 1.414L10 11.414z"/>
                </svg>
            </symbol>
        </svg>
        <!-- logout -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-logout">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M11.586 11H7a1 1 0 0 1 0-2h4.586l-1.293-1.293a1 1 0 0 1 1.414-1.414l3 3a.997.997 0 0 1 0 1.414l-3 3a1 1 0 0 1-1.414-1.414L11.586 11zM16 13a1 1 0 0 1 2 0v1.992C18 16.652 16.66 18 15.006 18H4.994A2.995 2.995 0 0 1 2 15.006V4.994A2.995 2.995 0 0 1 4.994 2h10.012A3 3 0 0 1 18 4.995V7a1 1 0 0 1-2 0V4.995A1 1 0 0 0 15.006 4H4.994A.995.995 0 0 0 4 4.994v10.012c0 .548.446.994.994.994h10.012c.546 0 .994-.45.994-1.008V13z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Actions -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-actions">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M10 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Circle -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-circle">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <circle cx="10" cy="10" r="4"/>
                </svg>
            </symbol>
        </svg>
        <!-- Eye -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-eye">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M10 16c-4.418 0-8-6-8-6s3.582-6 8-6 8 6 8 6-3.582 6-8 6zm0-2a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm1.912-4.589A2 2 0 0 1 10 12a2 2 0 1 1 .589-3.912 1 1 0 1 0 1.323 1.323z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Eye Closed -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-eye-closed">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M7.184 15.23l1.464-1.464a4 4 0 0 0 5.118-5.118l1.771-1.77A18.553 18.553 0 0 1 18 10s-3.582 6-8 6c-.991 0-1.94-.302-2.816-.77zm-2.721-2.107C2.945 11.583 2 10 2 10s3.582-6 8-6c.991 0 1.94.302 2.816.77l-1.464 1.464a4 4 0 0 0-5.118 5.118l-1.771 1.77zM15 4l1 1L5 16l-1-1L15 4z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Burger -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-burger">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M3 7a1 1 0 1 1 0-2h14a1 1 0 0 1 0 2H3zm0 4a1 1 0 0 1 0-2h14a1 1 0 0 1 0 2H3zm0 4a1 1 0 0 1 0-2h14a1 1 0 0 1 0 2H3z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Help -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-help">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M4.083 11A6.005 6.005 0 0 0 9 15.917v-2.043A4.007 4.007 0 0 1 6.126 11H4.083zm0-2h2.043A4.007 4.007 0 0 1 9 6.126V4.083A6.005 6.005 0 0 0 4.083 9zM11 15.917A6.005 6.005 0 0 0 15.917 11h-2.043A4.007 4.007 0 0 1 11 13.874v2.043zM15.917 9A6.005 6.005 0 0 0 11 4.083v2.043A4.007 4.007 0 0 1 13.874 9h2.043zM10 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm0-6a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Info -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-info">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M9.002 10l-.001 3H9a1 1 0 0 0 0 2h2s1-.003 1-1-1-.997-1-.997V9s-.003-1-1-1c-.03 0-.058 0-.086.003L9 8a1 1 0 1 0 0 2h.002zM2 3.994C2 2.893 2.895 2 3.994 2h12.012C17.107 2 18 2.895 18 3.994v12.012A1.995 1.995 0 0 1 16.006 18H3.994A1.995 1.995 0 0 1 2 16.006V3.994zM10 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/></svg>
            </symbol>
        </svg>
        <!-- Long Dash -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-dash-l">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4 10c0-.552.456-1 1.002-1h9.996A.999.999 0 0 1 16 10c0 .552-.456 1-1.002 1H5.002A.999.999 0 0 1 4 10z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Company -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-company">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M12 8h6v10H2V2h10v6zM4 4v12h6V4H4zm2 2h2v2H6V6zm0 4h2v2H6v-2zm6 0v6h4v-6h-4z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Website -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-website">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M18 3.994v12.012c0 1.1-.893 1.994-1.994 1.994H3.994C2.894 18 2 17.107 2 16.006V3.994C2 2.894 2.893 2 3.994 2h12.012C17.106 2 18 2.893 18 3.994zM16 8H4v8h12V8zM5 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm2-1c0 .556.447 1 .998 1h7.004A.999.999 0 0 0 16 5c0-.556-.447-1-.998-1H7.998A.999.999 0 0 0 7 5z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Email -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-email">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M16 6.25V7l-5.288 5.29a1.01 1.01 0 0 1-1.424 0L4 7V6h2l4 4 4-4h2v.25V6H4v8h12V6.25zM2 5.002A1 1 0 0 1 3 4h14c.552 0 1 .456 1 1.002v9.996A1 1 0 0 1 17 16H3c-.552 0-1-.456-1-1.002V5.002z"/>
                </svg>
            </symbol>
        </svg>
        <!-- External Link -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-external-link">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M14.586 4H13a1 1 0 0 1 0-2h4a.997.997 0 0 1 1 1v3.996a1 1 0 0 1-2 0V5.414l-5.293 5.293a1 1 0 1 1-1.414-1.414L14.586 4zM9 2a1 1 0 1 1 0 2H4.998C4.448 4 4 4.449 4 5.006v9.988C4 15.55 4.45 16 5.006 16h9.988c.555 0 1.006-.45 1.006-.998V11a1 1 0 0 1 2 0v4.002A3.004 3.004 0 0 1 14.994 18H5.006A3.005 3.005 0 0 1 2 14.994V5.006A3.001 3.001 0 0 1 4.998 2H9z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Trash -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-trash">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M4 7.997L16 8v7.003A3 3 0 0 1 13 18H7c-1.663 0-3-1.34-3-2.998V7.997zm5 3.012v1.982a1 1 0 1 0 2 0v-1.982a1 1 0 1 0-2 0zM6 14v1.002c0 .554.443.998 1 .998h6a1 1 0 0 0 1-.997V14a1 1 0 0 1-1-1.01v-1.98c0-.558.444-1.01 1-1.01V8h1.993a1 1 0 0 0 0-2H4.007a1 1 0 0 0 0 2H6v2a1 1 0 0 1 1 1.01v1.98C7 13.549 6.556 14 6 14zm2-8H6V3.999A2 2 0 0 1 7.99 2h4.02c1.1 0 1.99.893 1.99 1.999V6h-2V4H7.99C7.999 4 8 6 8 6z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Bank -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-bank">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M5.004 12v4h2v-4h-2zm-2-.26c-1.063-.612-1.407-2.161-.414-3.154l6-6a2 2 0 0 1 2.828 0l6 6c.993.993.65 2.542-.414 3.153V16c.552 0 1 .444 1 1v1h-16v-1c0-.552.444-1 1-1v-4.261zm12 .26h-2v4h2v-4zm-4 0h-2v4h2v-4zm-1-8l-6 6h12l-6-6zm0 5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Map Marker -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-map-marker">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M10.101 15.7a13.474 13.474 0 0 0 2.097-1.47C13.982 12.703 15 10.958 15 9A5 5 0 0 0 5 9c0 1.957 1.018 3.702 2.802 5.231A13.625 13.625 0 0 0 10 15.758l.101-.057zM10 18s-7-3-7-9a7 7 0 1 1 14 0c0 5.998-7 9-7 9zm0-7a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Credit Card -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-credit-card">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M2 5.002A1 1 0 0 1 3 4h14c.552 0 1 .456 1 1.002v9.996A1 1 0 0 1 17 16H3c-.552 0-1-.456-1-1.002V5.002zM4 6v8h12V6H4zm0 1h12v3H4V7z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Check Small -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-check-s">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M13.293 6.293a1 1 0 0 1 1.414 1.414l-6 6a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L8 11.586l5.293-5.293z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Custom Fields -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-custom-fields">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M4 4v2h12V4H4zm0-2h12a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm0 10h12a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2zm0 2v2h12v-2H4zm5.5-5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zm4 0h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zm4 0h.5v2h-.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zm-12 0h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zM2 9h.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H2V9z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Calendar -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-calendar">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M17 2c.552 0 1 .445 1 1v14c0 .552-.445 1-1 1H3c-.552 0-1-.445-1-1V3c0-.552.445-1 1-1h3v2h2V2h4v2h2V2h3zM4 6v10h12V6H4zm2 3h2v2H6V9zm0 3h2v2H6v-2zm3-3h2v2H9V9zm0 3h2v2H9v-2zm3-3h2v2h-2V9zm0 3h2v2h-2v-2z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Columns -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-columns">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M6 16c-.552 0-1-.456-1-1.002V5.002a.999.999 0 1 1 2 0v9.996A.999.999 0 0 1 6 16zm4 0c-.552 0-1-.456-1-1.002V5.002a.999.999 0 1 1 2 0v9.996A.999.999 0 0 1 10 16zm4 0c-.552 0-1-.456-1-1.002V5.002a.999.999 0 1 1 2 0v9.996A.999.999 0 0 1 14 16z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Blacklists -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-blacklists">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M6.554 12.032A3.981 3.981 0 0 1 6 10V7a4 4 0 0 1 7.508-1.923l2.785-2.784a1 1 0 0 1 1.414 1.414l-14 14a1 1 0 1 1-1.414-1.414l4.26-4.261zm5.41-5.41A2 2 0 0 0 8 7v3c0 .18.024.353.068.518l3.896-3.896zm-2.581 7.41L14 9.413V10c0 .992-.361 1.9-.959 2.599a8.007 8.007 0 0 1 3.392 2.644 1 1 0 1 1-1.608 1.19 5.989 5.989 0 0 0-5.442-2.402z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Webhooks -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-webhooks">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M9 7.83a3.001 3.001 0 1 1 2 0V11a1 1 0 0 1-1 1 2 2 0 1 0 2 2 1 1 0 0 1 2 0 4 4 0 1 1-5-3.874V7.829zM5 6a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm10 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm3 0a1 1 0 0 1 0-2v2zM2 6V4a1 1 0 1 1 0 2zm8 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Sticky Note -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-sticky-note">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M18 14v1l-3 3H2V2h16v12zm-2-2V4H4v12h8v-4h4zM6 7c0-.552.453-1 .997-1h6.006c.55 0 .997.444.997 1 0 .552-.453 1-.997 1H6.997A.996.996 0 0 1 6 7zm0 4a1 1 0 0 1 1.01-1h1.98a1 1 0 1 1 0 2H7.01C6.451 12 6 11.556 6 11zm8 3v2l2-2h-2z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Clip -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-clip">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M10.296 7.21a1.032 1.032 0 0 1 1.458-.012 1.03 1.03 0 0 1 .012 1.457l-2.081 2.114c-.083.08-.002.541.438.98l.18.182c.402.4 1.055.4 1.46-.005l3.573-3.569a2.06 2.06 0 0 0-.002-2.91l-.783-.783a2.061 2.061 0 0 0-2.915 0l-6.97 6.963a2.06 2.06 0 0 0 0 2.913l.782.782c.79.789 2.1.814 2.791.124a1.032 1.032 0 0 1 1.459 0 1.03 1.03 0 0 1 0 1.457c-1.51 1.508-4.125 1.457-5.708-.124l-.783-.782a4.12 4.12 0 0 1 0-5.827l6.97-6.962a4.126 4.126 0 0 1 5.833 0l.783.781a4.118 4.118 0 0 1 .001 5.825l-3.573 3.569a3.096 3.096 0 0 1-4.376.004l-.18-.18c-1.164-1.163-1.468-2.902-.432-3.901l2.063-2.096z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Loading -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-loading">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M10 18a1 1 0 0 1 0-2 6 6 0 1 0-6-6 1 1 0 0 1-2 0 8 8 0 1 1 8 8z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Product -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-product">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M4 5c0 .556.449 1 1.002 1h9.996a.999.999 0 1 0 0-2H5.002C4.456 4 4 4.448 4 5zm13 2.233v7.77A3.003 3.003 0 0 1 14.005 18h-8.01A3 3 0 0 1 3 15.003V7.237A2.99 2.99 0 0 1 2 5c0-1.658 1.352-3 3.002-3h9.996A2.999 2.999 0 0 1 17 7.233zM5 8v7.003a1 1 0 0 0 .995.997h8.01c.54 0 .995-.446.995-.997V8H5zm7.01 2c.546 0 .99.444.99 1a1 1 0 0 1-.99 1H7.99A.993.993 0 0 1 7 11a1 1 0 0 1 .99-1h4.02z"/>
                </svg>
            </symbol>
        </svg>
        <!-- API Key -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-api-key">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M10 16a6 6 0 1 0 0-12 6 6 0 0 0 0 12zm-1-5.268V13a1 1 0 0 0 2 0v-2.268a2 2 0 1 0-2 0zM10 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Coupon -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-coupon">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M10 6a1 1 0 1 1-2 0H4v1.17a3.001 3.001 0 0 1 0 5.66V14h4a1 1 0 0 1 2 0h6v-1.17a3.001 3.001 0 0 1 0-5.66V6h-6zm8 8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-3h1a1 1 0 0 0 0-2H2V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3h-1a1 1 0 0 0 0 2h1v3zM9 8a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0V9a1 1 0 0 1 1-1z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Tag -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-tag">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M4 12l4 4 8-8V4h-4l-8 8zm-1.414 1.414a2 2 0 0 1 0-2.828l8-8A2 2 0 0 1 12 2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-.586 1.414l-8 8a2 2 0 0 1-2.828 0l-4-4zM14 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Clone -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-clone">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M7 8H5v8h6v-2H9a2 2 0 0 1-2-2V8zm0-2V4a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h2zm2-2v8h6V4H9z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Edit -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-edit">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M13.293 10.707l-4-4-4.586 4.586 4 4 4.586-4.586zm1.414-1.414L16 8l-4-4-1.293 1.293 4 4zM6.586 16L4 13.414V16h2.586zm10.828-9.414a2 2 0 0 1 0 2.828l-8 8A2 2 0 0 1 8 18H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 .586-1.414l8-8a2 2 0 0 1 2.828 0l4 4z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Stop -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-stop">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M6.523 14.89a6 6 0 0 0 8.367-8.367l-8.367 8.368zM5.11 13.478l8.368-8.368a6 6 0 0 0-8.367 8.367zM10 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Unlock -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-unlock">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M13 9V7a3 3 0 0 0-6 0H5a5 5 0 1 1 10 0v2c1.105.003 2 .898 2 1.997v5.006A2.001 2.001 0 0 1 14.994 18H5.006A2.003 2.003 0 0 1 3 16.003v-5.006C3 9.894 3.897 9 5.006 9H13zm-8 7.003C5 16 8.331 15.999 14.994 16c.004 0 .006-1.668.006-5.003 0 .003-3.331.004-9.994.003C5.002 11 5 12.668 5 16.003z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Event -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-event">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M15.707 5.707l-1 1a1 1 0 0 1-1.414-1.414l1-1a1 1 0 0 1 1.414 1.414zM11 3v2a1 1 0 0 1-2 0V3a1 1 0 1 1 2 0zM4.293 5.707a1 1 0 0 1 1.414-1.414l1 1a1 1 0 0 1-1.414 1.414l-1-1zm11.414 8.586a1 1 0 0 1-1.414 1.414l-1-1a1 1 0 0 1 1.414-1.414l1 1zM11 17a1 1 0 0 1-2 0v-2a1 1 0 0 1 2 0v2zm-6.707-2.707l1-1a1 1 0 1 1 1.414 1.414l-1 1a1 1 0 1 1-1.414-1.414zM10 13a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2zM5 9a1 1 0 1 1 0 2H3a1 1 0 0 1 0-2h2zm12 0a1 1 0 0 1 0 2h-2a1 1 0 0 1 0-2h2z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Invoices -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-invoices">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M11.944 2.002a2 2 0 0 1 1.47.586l3 3A2 2 0 0 1 17 7.058v7.946a3.003 3.003 0 0 1-2.995 2.998h-8.01A3.003 3.003 0 0 1 3 15V5.004a2.996 2.996 0 0 1 3.003-3.002h5.941zm-.944 2H6.003A.996.996 0 0 0 5 5.004V15c0 .546.446 1.002.995 1.002h8.01c.54 0 .995-.447.995-.998V8.002h-3a1 1 0 0 1-1-1v-3zm-4 9a1 1 0 0 1 .99-1h4.02c.546 0 .99.444.99 1a1 1 0 0 1-.99 1H7.99a.993.993 0 0 1-.99-1zm0-4c0-.552.443-1 .999-1h1.002c.552 0 .999.444.999 1 0 .552-.443 1-.999 1H7.999a.997.997 0 0 1-.999-1z"/>
                </svg>
            </symbol>
        </svg>
        <!-- List -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-list">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M11.944 2.002a2 2 0 0 1 1.47.586l3 3A2 2 0 0 1 17 7.058v7.946a3.003 3.003 0 0 1-2.995 2.998h-8.01A3.003 3.003 0 0 1 3 15V5.004a2.996 2.996 0 0 1 3.003-3.002h5.941zm-.944 2H6.003A.996.996 0 0 0 5 5.004V15c0 .546.446 1.002.995 1.002h8.01c.54 0 .995-.447.995-.998V8.002h-3a1 1 0 0 1-1-1v-3zm-4 9a1 1 0 0 1 .99-1h4.02c.546 0 .99.444.99 1a1 1 0 0 1-.99 1H7.99a.993.993 0 0 1-.99-1zm0-4c0-.552.443-1 .999-1h1.002c.552 0 .999.444.999 1 0 .552-.443 1-.999 1H7.999a.997.997 0 0 1-.999-1z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Rules -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-rules">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M5 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm4 4.414l-2.707-2.706a3 3 0 1 1 1.414-1.414L9 12.585V7.829a3.001 3.001 0 1 1 2 0v4.757l1.292-1.293a3 3 0 1 1 1.414 1.414L11 15.415V17a1 1 0 0 1-2 0v-1.586zM15 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-5-5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Users -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-users">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M6.835 14.446A3.983 3.983 0 0 1 6 12v-1.535A3.982 3.982 0 0 1 4 11H3a1 1 0 0 1 0-2h1a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H3a1 1 0 1 1 0-2h1a4 4 0 0 1 4 4v.535A3.982 3.982 0 0 1 10 6c.729 0 1.412.195 2 .535V6a4 4 0 0 1 4-4h1a1 1 0 0 1 0 2h-1a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h1a1 1 0 0 1 0 2h-1a3.982 3.982 0 0 1-2-.535V12c0 .925-.314 1.777-.842 2.455 1.477.415 2.788 1.077 3.55 1.838a1 1 0 1 1-1.415 1.414c-.878-.878-3.219-1.702-5.295-1.707-2.093-.005-4.393.809-5.29 1.707a1 1 0 0 1-1.415-1.414c.771-.772 2.072-1.435 3.542-1.847zM10 8a2 2 0 0 0-2 2v2a2 2 0 1 0 4 0v-2a2 2 0 0 0-2-2z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Sharp -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-sharp">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M12 14H8v3a1 1 0 0 1-2 0v-3H3a1 1 0 0 1 0-2h3V8H3a1 1 0 1 1 0-2h3V3a1 1 0 1 1 2 0v3h4V3a1 1 0 0 1 2 0v3h3a1 1 0 0 1 0 2h-3v4h3a1 1 0 0 1 0 2h-3v3a1 1 0 0 1-2 0v-3zm0-2V8H8v4h4z"/>
                </svg>
            </symbol>
        </svg>
        <!-- At -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-at">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M18 10a3 3 0 0 1-4.8 2.4A4 4 0 1 1 14 10a1 1 0 0 0 2 0 6 6 0 1 0-6 6 1 1 0 0 1 0 2 8 8 0 1 1 8-8zm-8 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"/>
                </svg>
            </symbol>
        </svg>
        <!-- File -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-file">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M11.944 2.002a2 2 0 0 1 1.47.586l3 3A2 2 0 0 1 17 7.058v7.946a3.003 3.003 0 0 1-2.995 2.998h-8.01A3.003 3.003 0 0 1 3 15V5.004a2.996 2.996 0 0 1 3.003-3.002h5.941zm-.944 2H6.003A.996.996 0 0 0 5 5.004V15c0 .546.446 1.002.995 1.002h8.01c.54 0 .995-.447.995-.998V8.002h-3a1 1 0 0 1-1-1v-3z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Download -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-download">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M11 10.586l2.293-2.293a1 1 0 0 1 1.414 1.414l-4 4a1.002 1.002 0 0 1-1.414 0l-4-4a1 1 0 0 1 1.414-1.414L9 10.586V3a1 1 0 1 1 2 0v7.586zM16 16v-4a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-5a1 1 0 0 1 2 0v4h12z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Export -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-export">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M11 5.414V13a1 1 0 0 1-2 0V5.414L6.707 7.707a1 1 0 0 1-1.414-1.414l4-4a1 1 0 0 1 1.414 0l4 4a1 1 0 1 1-1.414 1.414L11 5.414zM16 12h-2a1 1 0 0 1 0-2h3a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h3a1 1 0 0 1 0 2H4v4h12v-4z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Data Exports -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-data-exports">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M4 9.002V15a1 1 0 0 0 1 1h9a1 1 0 0 1 0 2H5a3 3 0 0 1-3-3V7a1 1 0 0 1 .293-.707l4-4A1 1 0 0 1 7 2h7a1 1 0 0 1 0 2H8.002v4.002a1 1 0 0 1-1 1H4zM14.586 9l-1.293-1.293a1 1 0 1 1 1.414-1.414l3 3a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1-1.414-1.414L14.586 11H10a1 1 0 0 1 0-2h4.586z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Shipping -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-shipping">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M15.83 15a3.001 3.001 0 0 1-5.66 0H7.83A3.001 3.001 0 0 1 2 14V5a2 2 0 0 1 2-2h8v3h2.414L18 9.586V15h-2.17zm0-2H16v-2.586L13.586 8H12v3.17A3.001 3.001 0 0 1 15.83 13zM10 13V5H4v6.17A3.001 3.001 0 0 1 7.83 13H10zm-5 2a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm8 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Plus -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-plus">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M11 9h4a1 1 0 0 1 0 2h-4v4a1 1 0 0 1-2 0v-4H5a1 1 0 0 1 0-2h4V5a1 1 0 1 1 2 0v4z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Drag -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-drag">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M8 7a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm0 4a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm4-4a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm0 4a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm-4 4a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm4 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Reset -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-reset">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M16 4.708V2.991c0-.547.444-.991 1-.991a1 1 0 0 1 1 .99v4.02a1 1 0 0 1-.99.99h-4.02A.993.993 0 0 1 12 7a1 1 0 0 1 .99-1h1.482A6 6 0 1 0 16 10h2a8 8 0 1 1-2-5.292z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Drag Move -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-drag-move">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M9 14.586V11H5.414l.293.293a1 1 0 0 1-1.414 1.414l-2-2a1 1 0 0 1 0-1.414l2-2a1 1 0 0 1 1.414 1.414L5.414 9H9V5.414l-.293.293a1 1 0 0 1-1.414-1.414l2-2a1 1 0 0 1 1.414 0l2 2a1 1 0 1 1-1.414 1.414L11 5.414V9h3.586l-.293-.293a1 1 0 1 1 1.414-1.414l2 2a1 1 0 0 1 0 1.414l-2 2a1 1 0 0 1-1.414-1.414l.293-.293H11v3.586l.293-.293a1 1 0 0 1 1.414 1.414l-2 2a.997.997 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414l.293.293z"/>
                </svg>
            </symbol>
        </svg>
        <!-- World -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-world">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M4.083 11a6.005 6.005 0 0 0 2.862 4.165c-.488-1.154-.816-2.588-.914-4.165H4.083zm0-2h1.948c.098-1.577.426-3.011.914-4.165A6.005 6.005 0 0 0 4.083 9zm11.834 0a6.005 6.005 0 0 0-2.862-4.165c.488 1.154.816 2.588.914 4.165h1.948zm0 2h-1.948c-.098 1.577-.426 3.011-.914 4.165A6.005 6.005 0 0 0 15.917 11zm-7.882 0c.105 1.463.436 2.784.925 3.762C9.402 15.646 9.821 16 10 16c.179 0 .598-.354 1.04-1.238.489-.978.82-2.3.925-3.762h-3.93zm0-2h3.93c-.105-1.463-.436-2.784-.925-3.762C10.598 4.354 10.179 4 10 4c-.179 0-.598.354-1.04 1.238-.489.978-.82 2.3-.925 3.762zM10 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Integrations -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-integrations">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M5 13.586v-4.93a5 5 0 0 1 1.464-3.535l1.829-1.828a1 1 0 0 1 1.414 0L11 4.586l1.293-1.293a1 1 0 0 1 1.414 1.414L12.414 6 14 7.586l1.293-1.293a1 1 0 0 1 1.414 1.414L15.414 9l1.293 1.293a1 1 0 0 1 0 1.414l-1.828 1.829A5 5 0 0 1 11.343 15H6.414l-1.707 1.707a1 1 0 1 1-1.414-1.414L5 13.586zM7 13h4.343a3 3 0 0 0 2.121-.879L14.586 11 9 5.414 7.879 6.536A3 3 0 0 0 7 8.656V13zm1.293-3.293a1 1 0 0 1 1.414-1.414l2 2a1 1 0 0 1-1.414 1.414l-2-2z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Heart -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-heart">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M18 7c0 5-8 10-8 10S2 12 2 7c0-2.21 1.79-4 4-4s4 1.79 4 4c0-2.21 1.79-4 4-4s4 1.79 4 4z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Checkbox Checkmark -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-checkbox-checkmark">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M6.708 10.29c-.39-.39-1.024-.39-1.415 0-.39.39-.39 1.024 0 1.414l2 2.003c.39.39 1.023.39 1.414 0l6-6c.39-.39.39-1.024 0-1.414-.39-.39-1.024-.39-1.414 0L8 11.585 6.708 10.29z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Radio Checkmark -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-radio-checkmark">
                <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="10" cy="10" r="4" fill-rule="evenodd"/>
                </svg>
            </symbol>
        </svg>
        <!-- Radio Report Match -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-report-match">
                <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17 6.94a1 1 0 00-.05-.26v-.09a1 1 0 00-.2-.29l-4-4a1 1 0 00-.29-.19h-.1a1 1 0 00-.25 0H4A1 1 0 003 3v14a1 1 0 001 1h12a1 1 0 001-1V7v-.06zM15 16H5V4h6v3a1 1 0 001 1h3v8z"/>
                    <path d="M11.29 9.29L9 11.59l-.29-.29a1 1 0 00-1.41 1.41l1 1a1 1 0 001.41 0l3-3a1 1 0 00-1.42-1.42z"/>
                </svg>
            </symbol>
        </svg>
          <!-- ACTUAL Starred -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-star">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.323 7l1.749-4.371c.335-.839 1.521-.839 1.856 0L12.677 7H17c.89 0 1.337 1.077.707 1.707l-3.534 3.534 1.755 4.388c.356.889-.621 1.721-1.442 1.228L10 15.167l-4.486 2.69c-.82.493-1.798-.34-1.442-1.228l1.755-4.388-3.534-3.534C1.663 8.077 2.109 7 3 7h4.323z"/>
                </svg>
            </symbol>
        </svg>
        <!-- EMPTY Starred -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-star-empty">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.323 7l1.749-4.371c.335-.839 1.521-.839 1.856 0L12.677 7H17c.89 0 1.337 1.077.707 1.707l-3.534 3.534 1.755 4.388c.356.889-.621 1.721-1.442 1.228L10 15.167l-4.486 2.69c-.82.493-1.798-.34-1.442-1.228l1.755-4.388-3.534-3.534C1.663 8.077 2.109 7 3 7h4.323zm1.605 1.371A1 1 0 018 9H5.414l2.293 2.293a1 1 0 01.221 1.078l-.897 2.244 2.455-1.472a1 1 0 011.028 0l2.455 1.472-.897-2.244a1 1 0 01.22-1.078L14.587 9H12a1 1 0 01-.928-.629L10 5.693 8.928 8.37z"/>
                </svg>
            </symbol>
        </svg>
        <!-- Emulate permissions -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-emulate">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.2929 11.2929A.9969.9969 0 0113 11c1.1046 0 2-.8954 2-2V8c0-1.1046-.8954-2-2-2-.5523 0-1-.4477-1-1s.4477-1 1-1c2.2091 0 4 1.7909 4 4v1a3.984 3.984 0 01-.9368 2.5725C17.2239 12.2726 18 13.5457 18 15c0 .5523-.4477 1-1 1s-1-.4477-1-1c0-1.1046-.8954-2-2-2h-1c-.5523 0-1-.4477-1-1 0-.2761.112-.5261.2929-.7071zM7.707 12.707A.9969.9969 0 017 13H6c-1.1046 0-2 .8954-2 2 0 .5523-.4477 1-1 1s-1-.4477-1-1c0-1.4543.7761-2.7274 1.9368-3.4275A3.984 3.984 0 013 9V8c0-2.2091 1.7909-4 4-4 .5523 0 1 .4477 1 1s-.4477 1-1 1c-1.1046 0-2 .8954-2 2v1c0 1.1046.8954 2 2 2 .5523 0 1 .4477 1 1a.9969.9969 0 01-.2929.7071zM9 3c0-.5523.4477-1 1-1s1 .4477 1 1v2c0 .5523-.4477 1-1 1s-1-.4477-1-1V3zm0 6c0-.5523.4477-1 1-1s1 .4477 1 1v2c0 .5523-.4477 1-1 1s-1-.4477-1-1V9zm0 6c0-.5523.4477-1 1-1s1 .4477 1 1v2c0 .5523-.4477 1-1 1s-1-.4477-1-1v-2z" fill-rule="nonzero"/>
                </svg>
            </symbol>
        </svg>
        <!-- Billing Portal -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-billing-portal">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16 18h2V6H2v12h2c0-1.7448 1.1171-3.2287 2.6752-3.7754A3.9814 3.9814 0 016 12v-1c0-2.2091 1.7909-4 4-4 2.2091 0 4 1.7909 4 4v1a3.9814 3.9814 0 01-.6752 2.2246C14.8828 14.7713 16 16.2552 16 18zm-2 0c0-1.1046-.8954-2-2-2H8c-1.1046 0-2 .8954-2 2h8zm6-16.006v16.012C20 19.1054 19.1072 20 18.006 20H1.994C.8946 20 0 19.1072 0 18.006V1.994C0 .8946.8928 0 1.994 0h16.012C19.1054 0 20 .8928 20 1.994zM3 4c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1zm2-1c0 .5561.4466 1 .9975 1h11.005C17.5537 4 18 3.5523 18 3c0-.5561-.4466-1-.9975-1H5.9975C5.4463 2 5 2.4477 5 3zm5 6c-1.1046 0-2 .8954-2 2v1c0 1.1046.8954 2 2 2s2-.8954 2-2v-1c0-1.1046-.8954-2-2-2z"/>
                </svg>
            </symbol>
        </svg>
        <!-- App store -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-app-store">
                <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7 11a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2Zm10 0a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2ZM7 13H3v4h4v-4Zm10 0h-4v4h4v-4ZM7 1a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2Zm8 0a1 1 0 0 1 1 1l-.001 1.999L18 4a1 1 0 0 1 0 2l-2.001-.001L16 8a1 1 0 0 1-2 0l-.001-2.001L12 6a1 1 0 0 1 0-2l1.999-.001L14 2a1 1 0 0 1 1-1ZM7 3H3v4h4V3Z"/>
                </svg>
            </symbol>
        </svg>
        <!-- KYC -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-kyc">
                <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 2a7 7 0 0 1 5.6 11.201.837.837 0 0 1 .107.092l3 3a1 1 0 0 1-1.414 1.414l-3-3a1.009 1.009 0 0 1-.094-.108A7 7 0 1 1 9 2Zm0 10a2 2 0 0 0-1.96 1.601A4.986 4.986 0 0 0 9 14c.695 0 1.357-.142 1.959-.398A1.998 1.998 0 0 0 9 12Zm0-8a5 5 0 0 0-3.666 8.4A4.003 4.003 0 0 1 6.6 10.8a3 3 0 1 1 4.799.002 4 4 0 0 1 1.267 1.597A5 5 0 0 0 9 4Zm0 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z" fill-rule="nonzero"/>
                </svg>
            </symbol>
        </svg>
        <!-- One column -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-one-column"> <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
                <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16 2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12Zm0 2H4v12h12V4Z" fill-rule="nonzero"/>
                </svg>
            </symbol>
        </svg>
        <!-- Two columns -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-two-columns"> <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
                <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16 2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12ZM9 4H4v12h5V4Zm7 0h-5v12h5V4Z" fill-rule="nonzero"/>
                </svg>
            </symbol>
        </svg>
        <!-- Cake -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-cake">
                <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg"><path d="M14 5a1 1 0 0 1 1 1v2h1a2 2 0 0 1 2 2v8H2v-8a2 2 0 0 1 2-2h1V6a1 1 0 1 1 2 0v2h2V6a1 1 0 1 1 2 0v2h2V6a1 1 0 0 1 1-1Zm2 9H4v2h12v-2Zm0-4H4v2h12v-2Zm-6-8a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM6 2a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm8 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z" fill-rule="nonzero"/></svg>
            </symbol>
        </svg>
        <!-- Briefcase -->
        <svg xmlns="http://www.w3.org/2000/svg">
            <symbol id="icon-briefcase">
                <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg"><path d="M12 3a2 2 0 0 1 2 2v2h4v10H2V7h4V5a2 2 0 0 1 2-2h4Zm-1 8H9V9H4v6h12V9h-5v2Zm1-6H8v2h4V5Z" fill-rule="nonzero"/></svg>
            </symbol>
        </svg>
`;

export default sprites;
